import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import Canvas from '@groovepages/gd-canvas/Canvas';
import VuePapaParse from 'vue-papa-parse';
import App from './components/App.vue';
import store from './state';
import router from './router';
import wait from './plugins/wait';
import './components';
import './plugins';
import '@groovepages/gd-ui-kit/styles.css';
import './assets/css/custom_editor.scss';
import config from '../../load-config';
import i18n from './plugins/i18n';

Vue.use(Canvas);
Vue.use(Vuex);
Vue.use(VuePapaParse);

config.then(configValues => {
  axios.defaults.baseURL = `${configValues.VUE_APP_API_URL}/grooveblog`;

  let appFrontendURL = configValues.VUE_APP_FRONTEND_URL;

  if (configValues.VUE_APP_FRONTEND_URL.includes('/groovepages')) {
    appFrontendURL = configValues.VUE_APP_FRONTEND_URL.replace(
      '/groovepages',
      ''
    );
  }
  const user = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))
    : null;
  if (user && !user.auth_keycloak) {
    axios.defaults.headers.common = {
      ...axios.defaults.headers.common,
      'x-auth-provider': 'auth0'
    };
  }

  const localConfig = {
    apiUrl: `${configValues.VUE_APP_API_URL}/grooveblog`,
    appUrl: `${configValues.VUE_APP_GROOVEBLOG_URL}`,
    grooveappsurl: appFrontendURL,
    grooveblogUrl: 'https://{subdomain}.grooveblog.net/',
    apiCoreUrl: `${configValues.VUE_APP_API_URL}`
  };
  window.config = localConfig;
  window.gdEnv = configValues;

  Vue.config.productionTip = false;

  store.dispatch('initCore').then(() => {
    new Vue({
      el: '#app',
      store,
      i18n,
      router,
      wait,
      ...App
    });
  });
});
